import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
	IS_EMPTY,
	IS_NOT_EMPTY,
	IS_NOT_NULL_OR_UNDEFINED,
	IS_NULL_OR_UNDEFINED,
	QUICK_SEARCH_ACCOUNTS_TABLE,
	QuickSearchAccountResult,
	RestService,
} from 'cargo-chief-commons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';

@Component({
	selector: 'app-broker-search-results',
	templateUrl: './broker-search-results.component.html',
	styleUrls: ['./broker-search-results.component.scss'],
})
export class BrokerSearchResultsComponent implements OnInit {
	@Input() brokerSearchString: string = '';
	@Input() pendingHTTPRequests: Subject<void> = new Subject<void>();
	@Output() closePopover: EventEmitter<null> = new EventEmitter();

	isLoadingBrokersSearch: boolean = false;
	brokersList: Array<QuickSearchAccountResult> = null;
	recentlyViewedBrokers: Array<QuickSearchAccountResult> = null;

	IS_NULL_OR_UNDEFINED = IS_NULL_OR_UNDEFINED;
	IS_NOT_NULL_OR_UNDEFINED = IS_NOT_NULL_OR_UNDEFINED;
	IS_EMPTY = IS_EMPTY;
	IS_NOT_EMPTY = IS_NOT_EMPTY;

	constructor(
		private utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService
	) {}

	ngOnInit(): void {}

	initiateSearch() {
		if (IS_NOT_EMPTY(this.brokerSearchString)) {
			this.searchBrokers();
		} else if (
			IS_EMPTY(this.brokerSearchString) &&
			IS_NOT_NULL_OR_UNDEFINED(this.recentlyViewedBrokers) &&
			this.recentlyViewedBrokers.length > 0
		) {
			this.brokersList = null;
			this.copyRecentlyViewedBrokers();
		}
	}

	fetchRecentlyViewedBrokers() {
		if (
			IS_NOT_NULL_OR_UNDEFINED(this.recentlyViewedBrokers) &&
			this.recentlyViewedBrokers.length > 0
		) {
			this.copyRecentlyViewedBrokers();
		} else {
			this.searchBrokers({ firstSearch: true });
		}
	}

	copyRecentlyViewedBrokers() {
		this.brokersList = null;
		if (IS_NOT_NULL_OR_UNDEFINED(this.recentlyViewedBrokers)) {
			this.brokersList = [...this.recentlyViewedBrokers];
		}
	}

	searchBrokers({ firstSearch }: { firstSearch: boolean } = { firstSearch: false }) {
		this.brokersList = null;
		this.isLoadingBrokersSearch = true;
		const url = this.urlService.searchBrokers(this.brokerSearchString, 0, 5);
		this.restService
			.GET(url)
			.pipe(takeUntil(this.pendingHTTPRequests))
			.subscribe(
				(response) => {
					this.brokersList = QUICK_SEARCH_ACCOUNTS_TABLE(response.content);
					if (firstSearch) {
						this.recentlyViewedBrokers = this.brokersList;
					}
					this.isLoadingBrokersSearch = false;
				},
				(_) => {
					this.utilService.showSnackbar(
						'Unable to search brokers. Please try again after reloading the page.',
						SNACKBAR.ERROR,
						SNACKBAR.ACTION
					);
					this.brokersList = [];
					this.isLoadingBrokersSearch = false;
				}
			);
	}
}
